var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "approve",
  clipPath: "url(#clip0_4759_29529)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector ",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.334 1.75244C13.0915 1.75244 12.859 1.84876 12.6875 2.02021L6.45213 8.25561L6.02117 9.97947L7.74503 9.5485L13.9804 3.3131C14.1519 3.14165 14.2482 2.90912 14.2482 2.66665C14.2482 2.42419 14.1519 2.19166 13.9804 2.02021C13.809 1.84876 13.5764 1.75244 13.334 1.75244ZM11.9804 1.3131C12.3394 0.954117 12.8263 0.752441 13.334 0.752441C13.8417 0.752441 14.3286 0.954117 14.6875 1.3131C15.0465 1.67209 15.2482 2.15897 15.2482 2.66665C15.2482 3.17434 15.0465 3.66122 14.6875 4.02021L8.3542 10.3535C8.29012 10.4176 8.20983 10.4631 8.12192 10.4851L5.45525 11.1517C5.28486 11.1943 5.10462 11.1444 4.98043 11.0202C4.85624 10.896 4.80632 10.7158 4.84891 10.5454L5.51558 7.87872C5.53756 7.7908 5.58302 7.71051 5.6471 7.64643L11.9804 1.3131ZM1.37096 2.70366C1.71477 2.35984 2.18109 2.16669 2.66732 2.16669H7.33398C7.61013 2.16669 7.83398 2.39055 7.83398 2.66669C7.83398 2.94283 7.61013 3.16669 7.33398 3.16669H2.66732C2.4463 3.16669 2.23434 3.25448 2.07806 3.41077C1.92178 3.56705 1.83398 3.77901 1.83398 4.00002V13.3334C1.83398 13.5544 1.92178 13.7663 2.07806 13.9226C2.23434 14.0789 2.4463 14.1667 2.66732 14.1667H12.0006C12.2217 14.1667 12.4336 14.0789 12.5899 13.9226C12.7462 13.7663 12.834 13.5544 12.834 13.3334V8.66669C12.834 8.39054 13.0578 8.16669 13.334 8.16669C13.6101 8.16669 13.834 8.39054 13.834 8.66669V13.3334C13.834 13.8196 13.6408 14.2859 13.297 14.6297C12.9532 14.9735 12.4869 15.1667 12.0006 15.1667H2.66732C2.18109 15.1667 1.71477 14.9735 1.37096 14.6297C1.02714 14.2859 0.833984 13.8196 0.833984 13.3334V4.00002C0.833984 3.51379 1.02714 3.04748 1.37096 2.70366Z",
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4759_29529"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgEditInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditInfo);
export default __webpack_public_path__ + "static/media/edit-info.84d41f56.svg";
export { ForwardRef as ReactComponent };